/*
 * 5-М2 «Моя неделя». Геометрия из макета «Мастер, доступ и заглушка — П1»:
 * имя дня шириной 64, полоса загрузки высотой 6, выходной пунктирной рамкой,
 * чип «сегодня» акцентной рамкой, чип «плотно» тёплой парой.
 *
 * Ни одного цвета в файле — только var() из токенов кабинета и master-tokens.css:
 * мастер смотрит телефон в зале с приглушённым светом, и тёмная тема здесь условие
 * читаемости, а не украшение. Это же требует сторож master-rules.test.ts.
 */

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: 0 var(--space-4) var(--space-4);
}

/* День — кнопка: он открывается «Моим днём», и это видно до нажатия. */
.day {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  /* Карточка — --bg-card: токена --surface в проекте нет, и объявление с ним было
     недействительным, из-за чего рабочий день оставался прозрачным, как выходной. */
  background: var(--bg-card);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

/*
 * Выходной — пунктиром и без заливки. Это не «отключённая» строка: нажать на неё можно,
 * день откроется. Пунктир говорит ровно одно — работать в этот день не надо.
 */
.dayOff {
  composes: day;
  border-style: dashed;
  background: transparent;
}

.dayHead {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
}

.dayName {
  flex: 0 0 64px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}

.dayNameOff {
  composes: dayName;
  color: var(--text-secondary);
  font-weight: var(--font-weight-regular);
}

.dayLine {
  flex: 1;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/* Чип «сегодня» — рамкой, а не заливкой: он отмечает, а не выделяет. */
.tagToday {
  flex: 0 0 auto;
  padding: 2px 8px;
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-pill, 999px);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  white-space: nowrap;
}

/*
 * «Плотно» — предупреждение, и потому заливкой: день, забитый на девять десятых,
 * не выдержит ни опоздания, ни разговора дольше обычного.
 */
.tagTight {
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: var(--radius-pill, 999px);
  background: var(--master-note-bg);
  color: var(--master-note-fg);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

.bar {
  display: block;
  height: 6px;
  border-radius: 3px;
  background: var(--border);
  overflow: hidden;
}

.barFill {
  display: block;
  height: 100%;
  background: var(--accent);
}

.detail {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/* Полоса «нет связи»: время загрузки читают ДО того, как поверят числам. */
.stale {
  margin: 0 var(--space-4) var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: var(--master-note-bg);
  color: var(--master-note-fg);
  font-size: var(--font-size-sm);
}

/* Один филиал из двух не ответил: неделя показывается, пропуск назван словами. */
.partial {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  margin: 0 var(--space-4) var(--space-2);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--master-hint-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
}

.note {
  margin: 0 var(--space-4) var(--space-4);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/*
 * День в двух точках: цель перехода спрашивается, а не угадывается.
 *
 * У мастера, работающего пн–чт «на Ленина» и пт «на Гагарина», молчаливый переход
 * в один из двух филиалов открывал «Мой день» не той точки — и день со сменой
 * читался там «у вас выходной».
 */
.targets {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: 2px;
}

.dayRow {
  composes: day;
  cursor: default;
}
